import React from "react";
import { useNavigate } from "react-router-dom";
import Shadows from "./Shadows";
import rightarrow from "../images/rightarrow.png";
import "../styles_css/Hero.css"; // siguro që ky CSS është i uniform

const HeroSection = ({ heading, mainHeading, subHeading, ctaText, navigatePath }) => {
  const navigate = useNavigate();

  return (
    <div className="hero">
      <Shadows />
      <h3 className="services-heading">{heading}</h3>
      <h1 className="main-heading">{mainHeading}</h1>
      <p className="subheading">{subHeading}</p>

      <a
        onClick={() => navigate(navigatePath)}
        className="cta-button"
      >
        <span className="button-text">{ctaText}</span>
        <span className="button-icon">
          <img src={rightarrow} alt="Arrow Icon" />
        </span>
      </a>
    </div>
  );
};

export default HeroSection;
